import angular from 'angular';
import kendo from '@progress/kendo-ui';
import _ from 'lodash';
import $ from 'jquery';
import * as actions from '../../store/actions';

angular.module('webTools').controller('SearchCtrl', ['$scope', '$rootScope', '$routeParams', '$location', '$timeout', '$window', 'Columns', 'GridTools', 'MenuBuilder', 'Auth', 'Search', 'ModalWindow', 'File', 'Utility', '$ngRedux',
    function ($scope, $rootScope, $routeParams, $location, $timeout, $window, Columns, GridTools, MenuBuilder, Auth, Search, ModalWindow, File, Utility, $ngRedux) {

        const store = $ngRedux.getState();

        $scope.loadTab = 'advanced';
        $scope.gridName = 'searchGrid';
        $scope.fileMenuOptions = [];

        $scope.detailsMargin = '-350px';
        
        $scope.forms = {};
        $scope.kendo = $scope.kendo || {}; 
        $scope.breadcrumb = [{ path: 'Advanced Search', breadcrumbName: 'Advanced Search' }];

        $rootScope.view = 'Searches';
        $scope.breadcrumbEnabled = true;
        $scope.currentQuickSearch = '';

        $scope.viewOnly = store.app.webViewMode;

        if (!$routeParams.page) {
          $location.search('page', 1);
          window.history.replaceState({}, '', $location.url());
        }

      //if ($routeParams.q) {
      //  $scope.$broadcast('reloadGrid');
      //}

        $rootScope.quickSearch = $routeParams.q ? true : false;

        $scope.propertiesControl = {};
        $scope.showError = false;

        $scope.editSearchPath = false;

        /* eslint-disable  no-useless-escape */
        $scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
        /* eslint-enable  no-useless-escape */

        $scope.resetForm = function() {
            $scope.forms.advancedSearchForm.$setPristine();
            $scope.searchForm = angular.copy($scope.pristineSearchForm); 
            //$scope.kendo.profileDropDown.value($scope.searchForm.profileName)
            //$scope.selectedProfile = $scope.searchForm.profileName;

            $scope.kendo.profileDropDown.value($scope.defaultProfile);
            $scope.selectedProfile = $scope.defaultProfile;
            $scope.searchForm.profileName = $scope.defaultProfile;
            $scope.$broadcast('refreshProperties', $scope.defaultProfile);

            $scope.kendo.fileDateType.selectedIndex = 0;

            $scope.showDateOne = false;
            $scope.kendo.fileDateOne.value('');
            $scope.showDateTwo = false;
            $scope.kendo.fileDateTwo.value('');
            $scope.showTimespan = false;
        }

        $scope.setWorkingFolder = function() {
            $rootScope.workingFolder = $routeParams.folder ? $routeParams.folder : 'locator search bar';
            if ($routeParams.search) { $rootScope.workingFolder = $routeParams.search; }
        }

        Search.getPageSettings().then(function(settings) {

            $scope.editSearchPath = settings.EditSearchPath === '1' ? true : false;

            if (settings.DefaultSearchProfile !== '' && !$routeParams.profile) {
                $scope.defaultProfile = settings.DefaultSearchProfile;
                $scope.kendo.profileDropDown.value(settings.DefaultSearchProfile);
                $scope.selectedProfile = settings.DefaultSearchProfile;
                $scope.searchForm.profileName = settings.DefaultSearchProfile;
                //$scope.pristineSearchForm.profileName = settings.DefaultSearchProfile;
            }
        })

        $scope.$on("kendoWidgetCreated", function(event, widget){
            if (widget === $scope.kendo.tabstrip) {
                if ($routeParams.q) {
                    $scope.kendo.tabstrip.select(0);
                }
                if ($routeParams.search) {
                    $scope.kendo.tabstrip.select(1);
                }
            }
        });

        $scope.tabSelect = function(e) {
            if (e.item.id === 'advancedSearch') {
                if ($routeParams.search) {
                    $scope.currentSavedSearch = $routeParams.search;
                }
                //if (!$routeParams.q && !$routeParams.folder) { $scope.$broadcast('hideGrid'); }
                $location.search({ advanced: true, page: 1 });
            } else {
                if ($scope.currentSavedSearch) {
                    $location.search({ search: $scope.currentSavedSearch, page: 1 });
                } else {
                    //$location.search({ folder: 'Searches', page: 1 });
                }
            }
        }

        $scope.nodeSelect = function(e) {

            var node = e.sender.dataItem(e.node);

            if (node.Folder === '0') {
                $location.search({ folder: node.id, page: 1 });
            } else {
                $location.search({ search: node.id, page: 1 });
            }

            //$scope.setNavigation();
        };

        $scope.getColumns = function() {
            if (!$routeParams.folder) {
                if ($scope.viewOnly === 'true') {
                    return Columns.getDocumentColums($rootScope.workingFolder, 'Search Documents', true);
                } else {
                    return Columns.getDocumentColums($rootScope.workingFolder, 'Search Documents');
                }
            } else {
                return Columns.getSearchColumns($rootScope.workingFolder);
            }
        };

        $scope.resizeCalendar = (e) => {
            let calendar = e.sender.dateView.calendar;
            calendar.wrapper.width(e.sender.wrapper.width() - 6);
        }

      $scope.searchGridOptions = {
            mainGrid: true,
            allowRowSelect: true,
            allowMultiselect: true,
            allowColumnState: true,
            allowSelectFolders: false,
            enableContextMenu: true,
            columnMenu: true,
            sortable: true,
            resizable: true,
            reorderable: true,
            responsive: true,
            scrollable: true,
            pageable: {
                info: true,
                refresh: false
            }
        };

        $scope.searchForm = {
            path: 'Documents',
            filename: '',
            filenameOperator: 'like',
            fullText: '',
            fullTextOperator: 'all',
            documentStatus: '',
            description: '',
            versionNotes: '',
            documentNotes: '',
            checkedOutBy: '',
            createdBy: '',
            fileDateDuration: '',
            fileDateDurationType: 'Years',
            fileDateOne: '',
            fileDateOperation: 'Equals',
            fileDateType: '',
            fileDateTwo: '',
            fileSize: '',
            fileSizeOperator: '>=',
            lastUpdatedBy: '',
            lastAccessedBy: '',
            profileName: '[ Any Property ]',
            recordPolicy: '',
            recordCategory: '',
            recordStatus: '',
            recordManager: '',
            recordLocked: false,
            properties: [],
            routeName: '',
            routeStepName: '',
            routeParticipant: '',
            workflowComments: '',
            workflowSubmittedBy: '',
            workflowActive: false,
            workflowStepActive: false,
            versionHistory: 'Current Version',
            last: '',
            lastOperator: 'days',
            nonVersionedFiles: false,
            compressedFiles: false,
            dependentMaster: false,
            dependentChild: false,
            renderedPDF: false,
            subFolders: true,
            templateFiles: false,
            blockSecurity: false,
        };

        $scope.pristineSearchForm = angular.copy($scope.searchForm);
        //$scope.advancedSearchSaved = angular.copy($scope.searchForm);

        $scope.setGridOptions = function() {
            if ($routeParams.q) {
                $scope.advanced = false;
                $scope.searchGridOptions.loadOnInit = true;
                $scope.searchGridOptions.allowRowSelect = true;
                $scope.searchGridOptions.allowMultiselect = true;
                $scope.searchGridOptions.enableContextMenu = true;
                return 'api/search/GetQuickSearch'
            } else {
                $scope.searchGridOptions.allowRowSelect = true;
                $scope.searchGridOptions.enableContextMenu = true;
                return 'api/search/GetAdvancedSearch'
            }
        }

        $scope.setGridOptions();
        $scope.setWorkingFolder();

        $scope.searchData = {
            transport: {
                read: {
                    url: $scope.setGridOptions(),
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST'
                },
                parameterMap: function(data, operation) {

                    if (operation === 'read') { data = $.extend({ sort: [] }, data); }

                    var options = JSON.parse(localStorage.searchOptions);

                    if ($routeParams.q) {
                        data = $.extend(
                            {
                                query: $routeParams.q,
                                searchOptions: {
                                    filename: _.find(options, { text: 'Filename' }).checked,
                                    description: _.find(options, { text: 'Description' }).checked,
                                    versionNotes: _.find(options, { text: 'Version Notes' }).checked,
                                    propertyValues: _.find(options, { text: 'Property Values' }).checked,
                                    fullText: _.find(options, { text: 'Full Text' }).checked,
                                    workflowComments: _.find(options, { text: 'Workflow Comments' }).checked,
                                    useOrOperator: _.find(options, { text: 'Use OR Operator' }).checked
                                }
                            }, data);
                    } else if ($routeParams.search) {
                        data = $.extend(
                            {
                                query: $routeParams.search,
                                searchOptions: {}
                            }, data);
                    } else if ($routeParams.folder) {
                        data = $.extend(
                            {
                                folderId: $rootScope.workingFolder
                            }, data);
                    } else {
                        data = $.extend(
                            {
                                searchParameters: $scope.searchForm
                            }, data);
                    }

                    return angular.toJson(data);
                }
            },
            schema: {
                data: 'Data',
                total: 'TotalRows'
            },
            serverPaging: true,
            serverSorting: true,
            pageSize: 50,
            page: 1,
            sort: $scope.gridSort
        };

        $scope.currentPage = 1;
      $scope.$on('$routeUpdate', function (e, data) {

            if (_.isEmpty($routeParams)) {
                $timeout(function() { 
                    if ($scope.searchLink === true) {
                        $scope.searchLink = false;
                        $location.search({ folder: 'Searches', page: 1 });
                        return;
                    }
                })
            }

            /* eslint-disable  no-useless-escape */
            if ($scope.currentLocation === $location.url().replace(/page\=\d+/g, '') && !$rootScope.quickSearch) {
                $scope.closeDetailsPane();
            } else {
              if ($routeParams.q) {

                  if ($scope.currentQuickSearch !== $routeParams.nocache) {
                    $scope.$broadcast('reloadGrid');
                  }
                  
                  $scope.currentQuickSearch = $routeParams.nocache;

                  $scope.breadcrumbEnabled = false;
                  $rootScope.quickSearch = true;

                  $scope.searchInfo = 'Searched for "' + $routeParams.q + '"';
                  $rootScope.workingFolder = 'Locator Search Bar';
                }

                $scope.closeDetailsPane();
                $scope.setNavigation();
              $scope.searchData.transport.read.url = $scope.setGridOptions();

              if ($routeParams.advanced) {
                 
                $scope.breadcrumbEnabled = false;
                $rootScope.quickSearch = false;
                    $rootScope.workingFolder = 'Locator Search Bar';
                    $scope.selectedId = '';
                }
            }

            $scope.currentPage = data.params.page;
            $scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
            /* eslint-enable  no-useless-escape */
        });
        

        $scope.$on('$viewContentLoaded', function() {
            $scope.setNavigation();
        });

        $scope.setNavigation = function() {
            if ($routeParams.q) {
                $scope.breadcrumbEnabled = false;
                $scope.breadcrumb = [{
                    path: 'Quick Search',
                    breadcrumbName: 'Search for "' + $routeParams.q + '"',
                    isFolder: '0',
                    uid: ''
                }];
            } else {
                $scope.breadcrumbEnabled = false;
                $scope.breadcrumb = [{
                    path: 'Advanced Search',
                    breadcrumbName: 'Advanced Search',
                    isFolder: '0',
                    uid: ''
                }];
            }
        }

        $scope.$on('gridFolderLinkClicked', function(e, data) {
            var id = GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID;

            if ($routeParams.search || $routeParams.q || $routeParams.advanced) {
                if (_.includes(Auth.getAllowedNodes(), 'documents')) {
                    $scope.$apply(function() { $location.url('/documents').search({ folder: id, page: 1 }); });
                }
            } else {
                $scope.$apply(function() { $location.search({ folder: id, page: 1 }); });
            }
        })

        $scope.$on('gridSearchLinkClicked', function(e, data) {
            $scope.$apply(function() { $location.search({ search: GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID, page: 1 }); });
        })

        $scope.selectedId = '';

        angular.element('#details-pane').css({'display': 'block' })

        $scope.closeDetailsPane = function() {
		    if ($scope.detailsPaneIsOpen) { angular.element('#details-pane').css({'margin-right': '-350px'}) }
		    $scope.detailsPaneIsOpen = false;
		    $scope.$broadcast('detailsPaneClosed');
        };

		$scope.detailsPaneIsOpen = false;
		$scope.selectedObject = {};
		
		$scope.$on('gridItemSelected', function (e, data) {

			var wtObject = GridTools.getObjectFromGrid(data.id, $scope.kendo[$scope.gridName]._data);

			if(data.openDetails) {
				if (!$scope.detailsPaneIsOpen) {
					angular.element('#details-pane').css({ 'display': 'block' })
					$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
					$scope.detailsPaneIsOpen = true;
					$scope.selectedObject = wtObject;
				} else {
					if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
						$scope.selectedObject = wtObject;
					}
				}
			} else {
				if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
					$scope.selectedObject = wtObject;
				}
			}
			$scope.$apply();
		});

        $scope.selectedItems = [];

      $scope.$on('selectedItemsUpdated', function (e, selectedItems) {

            $scope.selectedItems = selectedItems;
            
            if (selectedItems.length === 0) { $scope.closeDetailsPane(); }

            if ($scope.selectedId !== '' && $scope.detailsPaneIsOpen) {
                if (!_.includes(_.map(selectedItems, 'ID'), GridTools.getObjectFromGrid($scope.selectedId, $scope.kendo[$scope.gridName]._data).ID)) {
                    if ($scope.detailsPaneIsOpen) {
                        var last = _.last(selectedItems).ID;
                        var o = _.find($scope.kendo[$scope.gridName]._data, function(ds) { return ds.ID === last; });
                        $scope.selectedId = o.uid;
                        $scope.$broadcast('populateDetails', o.uid);
                    }
                }
            }

            if (selectedItems.length === 0) {
              $scope.fileMenuOptions = [];
              $timeout(() => $scope.$apply())
              return;
            }

            if ($scope.searchForm.versionHistory !== 'Current Version') {
              $scope.fileMenuOptions = MenuBuilder.getVersionedSearchMenu(selectedItems, $scope.kendo[$scope.gridName]._data);
            }
            else if ($routeParams.search || $routeParams.q || $routeParams.advanced) {
                $scope.fileMenuOptions = MenuBuilder.getFileContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data, 'documents');
            }
        });

        $scope.setSearchPath = function(path, name, description) {
          Search.checkSearchExists(path, name).promise.then(function (exists) {
                if (exists === true) {
                    ModalWindow.openConfirmation('Overwrite existing search?',
                        function() {
                            $scope.saveSearch(path, name, description);
                        },
                        function() {
                            return;
                        });
                } else {
                    $scope.saveSearch(path, name, description);
                }
            });
        }

        $scope.saveSearch = function (path, name, description) {
            Search.saveSearch(path, name, description, $scope.searchForm).promise.then(function (data) {

                if ($scope.redirectUrl) {
                    alert("Search has been saved.")
                    $scope.searchForm = $scope.pristineSearchForm;
                    $location.url($scope.redirectUrl);
                } else {
                    $scope.successMessage = "Search has been saved."
                    $scope.showSuccessMessage();
                    $scope.advancedSearchSaved = angular.copy($scope.searchForm);
                }
            });
        }

      $scope.$on('launchLegacyDialog', function (e, data) {

        var fileIds = [];

        if ($scope.searchForm.versionHistory !== 'Current Version') {
          fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Version', 'Minor', 'Name', 'Type']));
        }
        else {
          fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Name', 'Type']));
        }

        var launch = function (legacyDialog) {
          window.launchLegacyDialog(legacyDialog, $scope.selectedItems, $rootScope.workingFolder, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
        }

        // Check to see if file is member of a project on delete
        if (data === 'delete') {
            File.isInProject(_.map($scope.selectedItems, function (item) { return "'" + item.ID + "'" }).toString()).then(function (returnData) {
                if (returnData === 'true') {
                    var m = "";
                    if ($scope.selectedItems.length === 1) {
                        m = "The selected file is in a project.<br/>Are you sure you want to delete?";
                    } else {
                        m = "One or more of the selected files are in a project.<br/>Are you sure you want to delete?";
                    }
                    ModalWindow.openConfirmation(m, function (data) { launch(data); });
                } else {
                    launch(data);
                }
            })
			} else { // Call React dialogs

        const packageCallback = () => { $scope.$broadcast('reloadGrid'); }

				switch (data) {
          case 'download':
            File.download(fileIds, 'download')
            break;
          case 'checkout':
            File.download(fileIds, 'checkout', packageCallback)
            break;
          case 'undocheckout':
            File.undoCheckout(fileIds, false, packageCallback);
            break;
					case 'quickapprovalworkflow':
						const modalOptions = {
							title: 'Quick Approval Workflow',
							maskClosable: false,
							footer: null
						}
						$ngRedux.dispatch(actions.showModal('QUICK_APPROVAL_WORKFLOW', modalOptions, { selectedItems: $scope.selectedItems }));
						break;
					case 'preview':
						let previewObject = {
              id: fileIds[0].ID,
              version: fileIds[0].Version,
              minor: fileIds[0].Minor
						}

						$scope.$emit('loadObjectPreview', previewObject);
            break;
          case 'bravahtml':
          case 'updateprofile':
            window.launchLegacyDialog(data, fileIds);
            break;
					default:
						launch(data);
						break;
				}
		    }
        });

        $scope.chooseSearchPath = function () {
            if ($scope.checkSearchForm()) {
                if (angular.equals($scope.searchForm, $scope.pristineSearchForm)) {
                    $scope.errorMessage = 'Please enter some search criteria.';
                    $scope.showErrorMessage();
                    return;
                }
                window.launchLegacyDialog('save-search', $scope.selectedItems, $rootScope.workingFolder, '', '', Auth.getUsername());
            }
        }

        $scope.$on('breadcrumbClicked', function(e, data) {
            //if (data.isFolder === '0') {
            $location.search({ folder: data.id, page: 1 });
            //}
        });
        
        $scope.closeDialog = function() {
            $scope.selectedId = '';
            $scope.$broadcast('reloadGrid');
        };

        $scope.filenameOptions = [
            { text: 'Like', value: 'like' },
            { text: '=', value: '=' },
            { text: '>', value: '>' },
            { text: '<', value: '<' },
            { text: '<=', value: '<=' },
            { text: '>=', value: '>=' },
            { text: '<>', value: '<>' }
        ];

        $scope.phrasesOptions = [
            { text: 'All', value: 'all' },
            { text: 'Any', value: 'any' },
            { text: 'Exact', value: 'exact' },
            { text: 'Forms', value: 'forms' },
            { text: 'Near', value: 'near' },
            { text: 'Advanced', value: 'advanced' }
        ];

        $scope.dateOptions = [
            { text: 'Created', value: 'Created' },
            { text: 'Imported', value: 'Imported' },
            { text: 'Last Accessed', value: 'Last Accessed' },
            { text: 'Last Updated', value: 'Last Updated' },
            { text: 'Checked Out', value: 'Checked Out' },
            { text: 'Version Created', value: 'Version Created' },
            { text: 'Workflow Requested', value: 'Workflow Requested' },
            { text: 'Workflow Completed', value: 'Workflow Completed' },
            { text: 'Record Policy Assigned', value: 'Record Policy Assigned' },
            { text: 'Record Action', value: 'Record Action' }
        ];

        $scope.dateOperations = [
            { text: 'Equals', value: 'Equals' },
            { text: 'Between', value: 'Between' },
            { text: 'Older Than', value: 'Older Than' },
            { text: 'Within', value: 'Within' }
        ];

        $scope.timespanOptions = [
            { text: 'Years', value: 'Years' },
            { text: 'Months', value: 'Months' },
            { text: 'Weeks', value: 'Weeks' },
            { text: 'Days', value: 'Days' },
            { text: 'Quarters', value: 'Quarters' }
        ];

        $scope.recordStatusOptions = [
            { text: '', value: '' },
            { text: 'Action Executed', value: '4' },
            { text: 'Expired', value: '3' },
            { text: 'Not Scheduled', value: '0' },
            { text: 'On Legal Hold', value: '2' },
            { text: 'Retirement Candidate', value: '5' },
            { text: 'Scheduled', value: '1' }
        ];

        $scope.sizeComparison = [
            { text: '>=', value: '>=' },
            { text: '>', value: '>' },
            { text: '<', value: '<' },
            { text: '<=', value: '<=' }
        ];

        $scope.versionOptions = [
            { text: 'Current Version', value: 'Current Version' },
            { text: 'All Versions', value: 'All Versions' },
            { text: 'Last 25 Versions', value: 'Last 25 Versions' },
            { text: 'Last 50 Versions', value: 'Last 50 Versions' }
        ];

        $scope.lastOptions = [
            { text: 'Days', value: 'days' },
            { text: 'Files', value: 'files' }
        ];

        const endpoint = store.app.endpoint;

        $scope.profileList = {
            transport: {
                read: {
                    url: `${endpoint ? endpoint : ''}/api/profiles/getprofilelist`,
                    contentType: 'application/json',
                    dataType: 'json'
                },
                parameterMap: function (data, operation) {
                    data = $.extend({ folderId: '' }, data);
                    return data;
                }
            },
            schema: {
                data: function(result) {
                    result.unshift({ ProfileID: "[ Any Profile ]" });
                    result.unshift({ ProfileID: "[ Any Property ]" });
                    return result
                }
            }
        };

        $scope.propertyList = [{ name: 'Any Property', type: 'text' }];
        $scope.showProperties = false;
        $scope.selectedProfile = '';

        $scope.loadProperties = function() {
            $scope.selectedProfile = $scope.kendo.profileDropDown.value();
        }

        $scope.showErrorMessage = function() {
            $scope.showError = true;
            $timeout(function() {
                $scope.showError = false;
            }, 4000)

        }

        $scope.showSuccessMessage = function() {
            $scope.showSuccess = true;
            $timeout(function() {
                $scope.showSuccess = false;
            }, 4000)

        }

        $scope.errorClick = function() {
            $scope.showError = false;
        }

        $scope.successClick = function() {
            $scope.showSuccess = false;
        }

      $scope.checkSearchForm = function () {
            $scope.searchForm.properties = $scope.propertiesControl.getPropertyValues(false, false);
            if (angular.equals($scope.searchForm, $scope.pristineSearchForm)) {
                $scope.errorMessage = 'Please enter some search criteria.';
                $scope.showErrorMessage();
                return false;
            }

            if ($scope.searchForm.fileDateType !== '') {
                if ($scope.searchForm.fileDateOperation !== 'Older Than' && $scope.searchForm.fileDateOperation !== 'Within') {
                    if (kendo.parseDate($scope.kendo.fileDateOne.value()) === null) {
                        $scope.errorMessage = 'File date value is not a valid date.';
                        $scope.showErrorMessage();
                        return false;
                    }
                    $scope.searchForm.fileDateOne = $scope.kendo.fileDateOne.value().toLocaleDateString().replace(/[\u200E]/g, "");

                    if ($scope.searchForm.fileDateOperation === 'Between') {
                        if (kendo.parseDate($scope.kendo.fileDateTwo.value()) === null) {
                            $scope.errorMessage = 'File date two value is not a valid date.';
                            $scope.showErrorMessage();
                            return false;
                        }
                        $scope.searchForm.fileDateTwo = $scope.kendo.fileDateTwo.value().toLocaleDateString().replace(/[\u200E]/g, "");
                    }
                } else {
                    if (kendo.parseInt($scope.searchForm.fileDateDuration) === null || kendo.parseInt($scope.searchForm.fileDateDuration) < 1) {
                        $scope.errorMessage = 'File duration value must be greater than zero.';
                        $scope.showErrorMessage();
                        return false;
                    }
                }
            }

            _.forEach(_.filter($scope.searchForm.properties, { 'propertyType': 'date' }), function (property) {
                if ((property.propertyValue !== '' && property.propertyValue !== null) || property.propertyOperator === 'Between') {
                    if (kendo.parseDate(property.propertyValue) === null) {
                        $scope.errorMessage = property.propertyName + ' value is not a valid date.';
                        $scope.showErrorMessage();
                        return false;
                    } else { property.propertyValue = kendo.parseDate(property.propertyValue).toLocaleDateString().replace(/[\u200E]/g, "") }
                    if (property.propertyOperator === 'Between') {
                        if (kendo.parseDate(property.propertyValue2) === null) {
                            $scope.errorMessage = property.propertyName + ' value two is not a valid date.';
                            $scope.showErrorMessage();
                            return false;
                        } else { property.propertyValue2 = kendo.parseDate(property.propertyValue2).toLocaleDateString().replace(/[\u200E]/g, "") }
                    }
                }
            });

            return true;
        }

        $scope.runSearch = function() {

            if ($scope.checkSearchForm()) {
                $scope.errorMessage = '';
                $scope.showError = false;
            
                $scope.searchForm.properties = $scope.propertiesControl.getPropertyValues(false, false);

                if ($scope.searchForm.versionHistory === 'Current Version') {
                  $scope.searchGridOptions.allowMultiselect = true;
                  $scope.searchGridOptions.enableContextMenu = true;
                } else {
                  $scope.searchGridOptions.allowMultiselect = false;
                  $scope.searchGridOptions.enableContextMenu = true;
                }

                if (!$routeParams.advanced) {
                    $location.search({ advanced: 'true', page: 1 });
                }

                if ($scope.errorMessage === '') {
                    $scope.selectedId = '';
                    $scope.$broadcast('reloadGrid');
                }
            }
        };

        $scope.showDateOne = false;
        $scope.showDateTwo = false;
        $scope.showTimespan = false;

        $scope.setVisibility = function(optionValue) {
            $scope.$apply(function() {
                switch (optionValue) {
                    case 'Equals':
                        $scope.showDateOne = true;
                        $scope.showDateTwo = false;
                        $scope.showTimespan = false;
                        break;
                    case 'Between':
                        $scope.showDateOne = true;
                        $scope.showDateTwo = true;
                        $scope.showTimespan = false;
                        break;
                    case 'Older Than':
                        $scope.showDateOne = false;
                        $scope.showDateTwo = false;
                        $scope.showTimespan = true;
                        break;
                    case 'Within':
                        $scope.showDateOne = false;
                        $scope.showDateTwo = false;
                        $scope.showTimespan = true;
                        break;
                    default:
                        break;
                }
            })
        };

        $scope.dateSearchSelected = function(e) {
            var item = e.dataItem;

            if (item.value !== '') {
                $scope.setVisibility($scope.kendo.dateComparison.value());
            } else {
                $scope.$apply(function() {
                    $scope.showDateOne = false;
                    $scope.showDateTwo = false;
                    $scope.showTimespan = false;
                });
            }
        };

        $scope.dateSearchTypeSelected = function(e) {
            var item = this.dataItem(e.item.index());
            if ($scope.kendo.fileDateType.value() !== '') {
                $scope.setVisibility(item.value);
            }
        };

        const navigateWarning = () => {
            if (!angular.equals($scope.searchForm, $scope.pristineSearchForm)) {
                return "Reloading or leaving this page will clear the current search.";
            }
        }

        window.addEventListener('beforeunload', function() { return 'test' });

        // $window.onbeforeunload = function() {
        //     if (!angular.equals($scope.searchForm, $scope.pristineSearchForm)) {
        //         return "Reloading or leaving this page will clear the current search.";
        //     }
        // }

		$scope.$on('openLinkDialog', function (e, data) {
			const directLink = Utility.getLinkURL($scope.selectedItems[0].ID);
            $ngRedux.dispatch(actions.showModal('DIRECT_LINK', {title: 'Link', footer: null, width: 400}, { directLink }));
		});

        $scope.$on('openRenameDialog', function (e, data) {
            ModalWindow.openRename($scope.selectedItems[0], false, function (newName) {
                $scope.$broadcast('reloadGrid');
            });
        });

        $scope.$on('$locationChangeStart', function(event, newLocation, oldLocation) {
            if ($location.path() !== '/search') {
                var newPath = $location.url();
                if (!angular.equals($scope.searchForm, $scope.pristineSearchForm) &&
                    ($scope.advancedSearchSaved && !angular.equals($scope.searchForm, $scope.advancedSearchSaved))) {
                    event.preventDefault();
                    ModalWindow.openConfirmation('Save advanced search?',
                        function() {
                            $scope.chooseSearchPath();

                            $scope.redirectUrl = newPath;
                        },
                        function() {
                            $scope.$apply(function() {
                                $scope.searchForm = $scope.pristineSearchForm
                                $location.url(newPath);
                            })
                        }
                    );
                }
            }
        })

        $scope.$on('$destroy', function() {
            $window.removeEventListener('beforeunload', navigateWarning);
        });

        $scope.$on('propertiesLoaded', function() {
            var p = $scope.propertiesControl.getPropertyValues(false, false);
            $scope.searchForm.properties = p;
            $scope.pristineSearchForm.properties = p;
        })

        $scope.loadSearch = function () {

            $scope.autoSearch = false;

            if ($routeParams.filePath) {
                $scope.autoSearch = true;
                $scope.searchForm.path = $routeParams.filePath;
            }

            if ($routeParams.fileName) {
                $scope.autoSearch = true;
                $scope.searchForm.filename = $routeParams.fileName;
            }

            if ($routeParams.fullTextValue) {
                $scope.autoSearch = true;
                $scope.searchForm.fullText = $routeParams.fullTextValue;
            }

            if ($routeParams.profile) {

                $scope.autoSearch = true;
                var propertyValues = {};

                _.forEach($routeParams, function (value, name) {
                    if (name.indexOf('DLPP_') !== -1) {
                        propertyValues[name.replace('DLPP_', '')] = value;
                    }
                })

                if (!_.isEmpty(propertyValues)) {
                    $scope.profilePropertyValues = propertyValues;
                }

                $scope.defaultProfile = $routeParams.profile;
                $scope.selectedProfile = $routeParams.profile;
                $scope.searchForm.profileName = $routeParams.profile;
            } else {
                $scope.defaultProfile = '[ Any Property ]';
            }

            if ($routeParams.subFolders) {
                $scope.autoSearch = true;
                $scope.searchForm.subFolders = JSON.parse($routeParams.subFolders.toLowerCase());
            }

            if ($scope.autoSearch) {
                $scope.$on('propertiesLoaded', function () {
                    $scope.runSearch();
                })
            }
        }();
    }
])

angular.module('webTools').service('Search', ['$q', '$http',
    function($q, $http) {

        return {
            getAdvancedSearch: function(data) {

                var promise = $q.defer();

                $http.post('/api/search/getadvancedsearch', data)
                .then(function(response) {
                    let data = response.data;
                    promise.resolve(data);
                });

                return promise;
            },
            checkSearchExists: function(path, name) {
                var promise = $q.defer();

                $http.post('/api/search/CheckSearchExists', { 'searchPath': path, 'searchName': name })
                .then(function(response) {
                    let data = response.data;
                    promise.resolve(data);
                });

                return promise;
            },
            saveSearch: function(path, name, description, parameters) {
                var promise = $q.defer();

                $http.post('/api/search/saveadvancedsearch', { 'searchPath': path, 'searchName': name, 'searchDescription': description, searchParameters: parameters })
                .then(function(response) {
                    let data = response.data;
                    promise.resolve(data);
                });

                return promise;
            },
            getPageSettings: function() {
                var defer = $q.defer();

                $http.get('/api/search/getpagesettings')
                .then(function(response) {
                    let data = response.data;
                    defer.resolve(data);
                });

                return defer.promise;
            }
        }
    }
]);